<template>
  <div>
    <div class="goods-remind">
      <div class="goods-remind-title">温馨提示</div>
      <div class="goods-remind-list">
        <b class="iconfont">正</b>
        <div>
          <div class="remind-title">正品保障</div>
          <div class="remind-msg">
            <p>商城所售产品均为全新正品，质量保证，请放心购买</p>
          </div>
        </div>
      </div>
      <div class="goods-remind-list">
        <i class="iconfont icon-xiangji_fill"></i>
        <div>
          <div class="remind-title">关于色差</div>
          <div class="remind-msg">
            <p>
              商品照片均为专业摄影师拍摄后和后期修正调整，尽量与现实商品保持一致。但由于灯光、显示器色彩偏差及个人对颜色理解各有不同，如有疑问，请与客服联系确认。
            </p>
          </div>
        </div>
      </div>
      <div class="goods-remind-list">
        <i class="iconfont icon-truck_fill"></i>
        <div>
          <div class="remind-title">关于发货</div>
          <div class="remind-msg">
            <p>
              <b>发货时间</b
              >：每日16:00前付款的订单当天发出，16:00以后付款于次日发出。（法定节假日及商城大型活动期间除外）
            </p>
            <p>
              <b>发货快递</b
              >：默认申通快递，大货、重货可发物流。如收货地不在配送范围内，可更改发货方式，但发货时间不能保证；
            </p>
            <p>
              <b>发货提醒</b
              >：请您务必在签收快递物流之前，确认商品完好无损再签收，检验商品过程中如发现缺货、少货、可以拒签并第一时间联系我们。
            </p>
          </div>
        </div>
      </div>
      <div class="goods-remind-list">
        <i class="iconfont icon-qianshou_fill"></i>
        <div>
          <div class="remind-title">关于签收</div>
          <div class="remind-msg">
            <p>
              为了确保亲们能收到完好的宝贝，我们提醒亲们在签收快递的时候，注意检査包装是否完好，并且是否有被拆过的痕迹哦！提醒亲们应该与与快递或物流当面验收您的快递包裹！
            </p>
          </div>
        </div>
      </div>
      <div class="goods-remind-list">
        <i class="iconfont icon-refund_fill"></i>
        <div>
          <div class="remind-title">7天无理由退换货原则</div>
          <div class="remind-msg">
            <p>
              A、本商城支持7天无理由退换货服务(签收后起168小时内)，如果您对商品不满意，在保存商品及包装原样情况下可以退换一次。商品及包裝原样指：商品未使用过、有吊牌、未拆标配件齐全、未改装过、无人为损坏、不影响二次销售。
            </p>
            <p>
              B、因质量问题造成的退换货邮费由我们承担，非质量问题造成的退换货邮费由买家承担
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
@import url("../../assets/css/iconfont.css");
.goods-remind {
  border-top: 1px solid #f3f3f3;
  padding-bottom: 20px;
}
.goods-remind-title {
  background: #e1251b;
  color: #ffffff;
  line-height: 40px;
  height: 40px;
  padding: 0 20px;
  font-size: 16px;
  margin-bottom: 15px;
}
.goods-remind .goods-remind-list {
  padding: 10px 25px 0 66px;
  position: relative;
}
.goods-remind .goods-remind-list .remind-title {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
  margin-bottom: 10px;
}
.goods-remind .goods-remind-list .iconfont {
  position: absolute;
  width: 34px;
  height: 34px;
  background: #e1251b;
  border-radius: 50%;
  left: 20px;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  line-height: 34px;
  top: 5px;
}
.goods-remind .goods-remind-list .remind-msg {
  color: #999999;
  border-bottom: 1px dashed #e4e4e4;
  padding-bottom: 15px;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/RemindGoods/index.vue